import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UplineRefferelService {

    constructor(private http: HttpClient) { }

    getParrentRefferelcode = (params: any) => {
        return this.http.get(environment.userApiUrl + 'api/admin/upline-referral', {params})
    }

       updateChildRefferelcode = (data: any) => {
        return this.http.post(environment.userApiUrl + 'api/admin/upline-referral', data)
    }
    
}
